// Регионы и города Беларуси
// Регионы и города Беларуси с указанием областного (центрального) города
export const belarusRegions = {
  'Минская область': {
    center: 'Минск',
    cities: [
      'Борисов',
      'Солигорск',
      'Молодечно',
      'Жодино',
      'Слуцк',
      'Вилейка',
      'Дзержинск',
      'Марьина Горка',
      'Несвиж',
      'Столбцы',
      'Смолевичи'
    ]
  },
  'Брестская область': {
    center: 'Брест',
    cities: [
      'Барановичи',
      'Пинск',
      'Кобрин',
      'Лунинец',
      'Береза',
      'Ивацевичи',
      'Пружаны',
      'Ганцевичи',
      'Дрогичин'
    ]
  },
  'Витебская область': {
    center: 'Витебск',
    cities: [
      'Орша',
      'Новополоцк',
      'Полоцк',
      'Глубокое',
      'Лепель',
      'Поставы',
      'Браслав',
      'Миоры',
      'Докшицы'
    ]
  },
  'Гомельская область': {
    center: 'Гомель',
    cities: [
      'Мозырь',
      'Жлобин',
      'Светлогорск',
      'Речица',
      'Калинковичи',
      'Рогачёв',
      'Добруш',
      'Житковичи',
      'Хойники'
    ]
  },
  'Гродненская область': {
    center: 'Гродно',
    cities: [
      'Лида',
      'Слоним',
      'Волковыск',
      'Сморгонь',
      'Новогрудок',
      'Мосты',
      'Щучин',
      'Ошмяны',
      'Берёзовка'
    ]
  },
  'Могилёвская область': {
    center: 'Могилёв',
    cities: [
      'Бобруйск',
      'Горки',
      'Осиповичи',
      'Кричев',
      'Шклов',
      'Быхов',
      'Климовичи',
      'Костюковичи',
      'Кировск'
    ]
  }
};

// Плоский список всех городов для поиска (включая областные центры)
export const allCities = Object.keys(belarusRegions).reduce((acc, region) => {
  const entry = belarusRegions[region];
  if (!entry) return acc;
  acc.push(entry.center);
  entry.cities.forEach(c => acc.push(c));
  return acc;
}, []).sort();

// Список регионов
export const regionsList = Object.keys(belarusRegions).sort();

// Функция для получения городов по региону (включая областной центр)
export const getCitiesByRegion = (region) => {
  const entry = belarusRegions[region];
  if (!entry) return [];
  return [entry.center, ...entry.cities];
};

// Получить областной центр региона
export const getRegionCenter = (region) => {
  const entry = belarusRegions[region];
  return entry ? entry.center : null;
};

// Получить города региона без областного центра
export const getCitiesExcludingCenter = (region) => {
  const entry = belarusRegions[region];
  return entry ? entry.cities : [];
};
